module.exports = new __parcel__URL__("hi-tom_11.de67cef1.mp3").toString();